class RouteMetaField {

    constructor(componentType, title=null, metaTags=[], newExternalPlugin=false) {
        if (!(componentType)){
            throw `[RouteMetaField][RouteMetaField field should include componentType]`
        }
        this.componentType = componentType
        this.title = title
        this.metaTags = metaTags
        this.newExternalPlugin = newExternalPlugin
    }

    toJSON(){
        let data = {componentType: this.componentType}
        if (this.title){
            data.title = this.title
        }
        if (this.metaTags){
            data.metaTags = this.metaTags
        }
        if (this.newExternalPlugin){
            data.newExternalPlugin = this.newExternalPlugin
        }
        return data
    }
}

export class Route {

    constructor(name, path,components={}, meta={}, children=[], props=true, beforeEnterFuncCallback=null, redirect=null) {
        this.name = name
        this.path = path
        this.components = components
        this.meta = new RouteMetaField(meta.componentType, meta.title?meta.title:null, meta.metaTags?meta.metaTags:[] , meta.newExternalPlugin?meta.newExternalPlugin:false).toJSON()
        if (!Object.keys(this.meta).includes("componentType") ){
            throw `[Route][Meta field should include componentType for route<${this.name}>]`
        }
        this.redirect = redirect
        this.children = []
        if (children.length !=0){
            for (const child of children) {
                this.children.push(child.toJSON())
            }
        }
        this.props = props
        this.beforeEnterFuncCallback = beforeEnterFuncCallback
        
    }

    toJSON() {
        let data = {
            name: this.name,
            path: this.path,
            components: this.components,
            meta: this.meta,
            children: this.children,
            props:this.props,
        }
        if (this.redirect!=null){
            data = {
                name: this.name,
                path: this.path,
                redirect: this.redirect
            }
        }
        if (this.beforeEnterFuncCallback){
            data.beforeEnter = this.beforeEnterFuncCallback
        }
        console.log("--------------------------Route", data)
        return data
    }
}